module.exports = __webpack_public_path__ + "/build/web/images/hero-about@3x.047ff8f99d453abb9637585ef311a096.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-about@3x.jpg
// module id = 135
// module chunks = 13